/* Source: /app/components/Index.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { PlayGroundLayout } from "./PlayGroundLayout.js";
import "../styles/global.css";
import { useState } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
function Index() {
  const [examples, setExamples] = useState([]);
  useEffect(() => {
    async function loadExamples() {
      let response = await __jacSpawn("load_example_list", "", {});
      setExamples(response.reports[0]);
    }
    loadExamples();
  }, []);
  return __jacJsx("main", {}, [__jacJsx(PlayGroundLayout, {"examples": examples}, [])]);
}
export {Index};